import React from "react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

export type LozengeAppearance =
    | "blue"
    | "neutral"
    | "yellow"
    | "saffron"
    | "lime"
    | "purple"
    | "danger";

export type LozengeProps = {
    appearance?: LozengeAppearance;
    text: string | React.ReactNode;
};

const appearanceColors = {
    blue: {
        backgroundColor: wacToken("color.extended.blue100"),
        color: wacToken("color.extended.blue800")
    },
    neutral: {
        backgroundColor: token("color.background.neutral"),
        color: token("color.text.subtle")
    },
    yellow: {
        backgroundColor: wacToken("color.extended.yellow100"),
        color: wacToken("color.extended.yellow800")
    },
    saffron: {
        backgroundColor: wacToken("color.extended.saffron100"),
        color: wacToken("color.extended.saffron800")
    },
    lime: {
        backgroundColor: wacToken("color.extended.lime100"),
        color: wacToken("color.extended.lime800")
    },
    purple: {
        backgroundColor: wacToken("color.extended.purple100"),
        color: wacToken("color.extended.purple800")
    },
    danger: {
        backgroundColor: token("color.background.danger", "#FFEBE6"),
        color: wacToken("color.secondary.red")
    }
};

export const Lozenge = ({ appearance = "neutral", text }: LozengeProps) => {
    if (!text) {
        return null;
    }

    const colors = appearanceColors[appearance] ?? appearanceColors.neutral;

    // Use inline styles instead of css prop to avoid CSS-in-JS compilation issues in tests
    const combinedStyles: React.CSSProperties = {
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        paddingInline: "8px",
        borderRadius: "20px",
        textAlign: "center",
        fontFamily: wacToken("font.charlie.text"),
        fontSize: "11px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: "0.3px",
        textTransform: "uppercase",
        maxWidth: "200px",
        boxSizing: "border-box",
        flexShrink: 0,
        width: "fit-content",
        backgroundColor: colors.backgroundColor,
        color: colors.color
    };

    return <div style={combinedStyles}>{text}</div>;
};
